module.exports = __webpack_public_path__ + "static/media/matilde-cap-brazil-happy.6eb99d6a.png";